import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';
import { isErrorResponse } from '../../utils/error-handlers';
import {
  DEFAULT_GET_CONFIG,
  DEFAULT_POST_CONFIG,
  DEFAULT_PUT_CONFIG,
} from '../../config/rest';
import {
  CLEAR_FREE_OF_CHARGE_CATEGORIES,
  CLEAR_FREE_OF_CHARGE_CATEGORY,
  FLAG_FREE_OF_CHARGE_CATEGORY_ACTIVITY,
  FLAG_GETTING_FREE_OF_CHARGE_CATEGORIES,
  GET_FREE_OF_CHARGE_CATEGORIES,
  GET_FREE_OF_CHARGE_CATEGORY,
} from '../types';
import { FREE_OF_CHARGE_CATEGORY_ENDPOINT } from '../../config/endpoints';
import { FREE_OF_CHARGE_CATEGORY_PATH } from '../../config/paths';

const flagGettingFreeOfChargeCategories = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_FREE_OF_CHARGE_CATEGORIES,
    payload: flag,
  });

const getFreeOfChargeCategories =
  async (tableFilters = null) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingFreeOfChargeCategories(true));
      const query = tableFilters;
      const url = `${FREE_OF_CHARGE_CATEGORY_ENDPOINT}?${QueryString.stringify(
        query,
      )}`;
      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
      await isErrorResponse(response, null, dispatch);
      const freeOfChargeCategories = await response.json();
      dispatch({
        type: GET_FREE_OF_CHARGE_CATEGORIES,
        payload: freeOfChargeCategories,
      });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingFreeOfChargeCategories(false));
    }
  };

const clearFreeOfChargeCategories = () => (dispatch) =>
  dispatch({
    type: CLEAR_FREE_OF_CHARGE_CATEGORIES,
  });

const clearFreeOfChargeCategory = () => (dispatch) =>
  dispatch({
    type: CLEAR_FREE_OF_CHARGE_CATEGORY,
  });

const flagFreeOfChargeCategoryActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_FREE_OF_CHARGE_CATEGORY_ACTIVITY,
    payload: flag,
  });

const postFreeOfChargeCategory =
  async ({ name, description, freeOfChargeSubCategoryList, active }) =>
  async (dispatch) => {
    try {
      dispatch(flagFreeOfChargeCategoryActivity(true));

      const payload = {
        name,
        description,
        freeOfChargeSubCategoryList,
        active,
      };

      const url = FREE_OF_CHARGE_CATEGORY_ENDPOINT;

      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payload),
      });

      await isErrorResponse(response, null, dispatch);

      const freeOfChargeCategory = await response.json();

      dispatch(
        push(`${FREE_OF_CHARGE_CATEGORY_PATH}/${freeOfChargeCategory.id}`),
      );
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagFreeOfChargeCategoryActivity(false));
    }
  };

const putFreeOfChargeCategory =
  async (
    freeOfChargeCategoryId,
    { name, description, freeOfChargeSubCategoryList, active },
  ) =>
  async (dispatch) => {
    try {
      dispatch(flagFreeOfChargeCategoryActivity(true));

      const payload = {
        id: freeOfChargeCategoryId,
        name,
        description,
        freeOfChargeSubCategoryList,
        active,
      };

      const url = `${FREE_OF_CHARGE_CATEGORY_ENDPOINT}/${freeOfChargeCategoryId}`;

      const response = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });

      await isErrorResponse(response, null, dispatch);

      const freeOfChargeCategory = await response.json();

      dispatch(
        push(`${FREE_OF_CHARGE_CATEGORY_PATH}/${freeOfChargeCategory.id}`),
      );
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagFreeOfChargeCategoryActivity(false));
    }
  };
const getFreeOfChargeCategory =
  async ({ freeOfChargeCategoryId }) =>
  async (dispatch) => {
    try {
      dispatch(flagFreeOfChargeCategoryActivity(true));

      const url = `${FREE_OF_CHARGE_CATEGORY_ENDPOINT}/${freeOfChargeCategoryId}`;

      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });

      await isErrorResponse(response, null, dispatch);

      const freeOfChargeCategory = await response.json();

      dispatch({
        type: GET_FREE_OF_CHARGE_CATEGORY,
        payload: freeOfChargeCategory,
      });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagFreeOfChargeCategoryActivity(false));
    }
  };

export {
  clearFreeOfChargeCategories,
  clearFreeOfChargeCategory,
  getFreeOfChargeCategories,
  getFreeOfChargeCategory,
  postFreeOfChargeCategory,
  putFreeOfChargeCategory,
};
